import MandateMW from "@/middlewares/Mandate";
import MeetingMW from "@/middlewares/Meeting";
import MeetingORM from "@/store/orm-axios/models/Meeting";
import MandateORM from "@/store/orm-axios/models/Mandate";

import { meetingMinutesNames } from "@/constants/meeting.js";

export default {
  methods: {
    // !!!: REMOVE instead of DELETE MANDATE TODO: remove event from meeting minutes
    REMOVE_MANDATE(mandate) {
      mandate = MandateORM.find(mandate.id);
      var self = this;
      self
        .$swal(self.alertQuestion())
        .then(res => {
          if (res.value) {
            // general overlay loader
            self.$store.state.showLoaderOverlay = true;
            // console.log(mandate);
            var meeting = MeetingORM.query().where("id", mandate.meeting_id).first();
            // console.log(meeting);
            var mandateRemoved = JSON.parse(JSON.stringify(mandate));
            var contact_id = mandateRemoved.representant_contact_id;

            mandateRemoved.representant_contact_id = null;
            mandateRemoved.representant_owner_id = mandate.building_owner_id;
            mandateRemoved.showed_up = 0;
            mandateRemoved.presence_status = null;
            MandateORM.update({
              where: mandateRemoved.id,
              data: mandateRemoved,
            });
            mandateRemoved = MandateORM.find(mandateRemoved.id);
            // console.log("mandateRemoved", mandateRemoved);
            MandateMW.PUT(mandateRemoved, false)
              .then(() => {
                let minutes = meeting.minutes;
                // NOTE: Prevent contact-arrived to be deleted until last representant is deleted
                if (this.arrivedContactRepresentants(meeting, contact_id) == 1) {
                  // NOTE: Remove contact-arrived event from minutes
                  minutes = this.removeContactArrivedEvent(meeting, contact_id);
                }
                minutes = this.changeMinutes(meeting, mandate, contact_id);

                // update in local orm
                MeetingORM.update({
                  where: mandate.meeting_id,
                  data(item) {
                    item.minutes = minutes;
                  },
                });
                meeting = MeetingORM.query().where("id", mandate.meeting_id).first();
                // update also in db
                MeetingMW.PUT(meeting, false)
                  .then(res => {
                    self.$store.state.showLoaderOverlay = false;
                    // console.log("res", res);
                  })
                  .catch(err => {
                    self.$store.state.showLoaderOverlay = false;
                    console.log("error", err);
                    self.$swal(self.alertError());
                  });
              })
              .catch(err => {
                self.$store.state.showLoaderOverlay = false;
                console.log("error", err);
                self.$swal(self.alertError());
              });
          }
        })
        .catch(err => {
          console.log("error", err);
          self.$swal(self.alertError());
        });
    },
    changeMinutes(meeting, mandate, contact_id) {
      var minutes = [];
      this.$_.each(meeting.minutes, minute => {
        if (
          minute.event == meetingMinutesNames.participant_arrived &&
          minute.building_owner_id != mandate.building_owner_id &&
          contact_id == null
        ) {
          minutes.push(minute);
        } else if (
          minute.event != meetingMinutesNames.mandate_moved &&
          minute.building_owner_id != mandate.building_owner_id
        ) {
          minutes.push(minute);
        } else if (minute.event == meetingMinutesNames.mandate_moved) {
          if (contact_id) {
            if (
              minute.move_to_representant_id != contact_id &&
              minute.move_from_representant_id != contact_id
            ) {
              minutes.push(minute);
            }
          } else {
            if (
              minute.move_to_representant_id != mandate.building_owner_id &&
              minute.move_from_representant_id != mandate.building_owner_id
            ) {
              // console.log("minute", minute);
              minutes.push(minute);
            }
          }
        }
      });
      return minutes;
    },
    removeContactArrivedEvent(meeting, contact_id) {
      if (!contact_id) {
        return meeting.minutes;
      }

      let minuteEventIndex = this.$_.findIndex(meeting.minutes, minute => {
        return (
          minute.event == meetingMinutesNames.contact_arrived &&
          minute.contact_id &&
          minute.contact_id == contact_id
        );
      });
      if (minuteEventIndex != "-1") {
        meeting.minutes.splice(minuteEventIndex, 1);
      }
      return meeting.minutes;
    },
    arrivedContactRepresentants(meeting, contact_id) {
      if (!contact_id) {
        return 0;
      }
      let contactRepresentants = this.$_.filter(meeting.minutes, minute => {
        return (
          minute.event != meetingMinutesNames.contact_arrived &&
          minute.representant_type == "contact" &&
          minute.representant_id == contact_id
        );
      });
      return contactRepresentants.length;
    },
  },
};
